import React from "react";

const CardText = (props) => {
  return <p className="card-text-button">{props.children}</p>;
};

export default CardText;
